function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#7E7E7E",
  stroke: "#7E7E7E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  d: "M50.4,31c0-2.6,0-4.6,0-6.6 C50.7,12.7,59.3,3.9,71,3.8c15-0.1,30-0.1,45,0c13.8,0,22.2,8.6,22.4,22.5c0,1.3,0,2.6,0,4.7c8.7,0,17.1,0,25.5,0 c7.1-0.1,13.1,2.6,17.4,8.3c7.5,9.8,4.6,23.4-6.7,29.4c-3.7,2-4.2,4.2-4.2,7.7c0.1,40.5,0,81,0.1,121.4c0,9.8-2.5,18.9-11,24.4 c-4.5,2.9-10.3,5.3-15.6,5.4c-33,0.5-66,0.4-99,0.2c-14.5-0.1-25-10.6-26.3-25.5c-0.2-2.2-0.2-4.3-0.2-6.5c0-40,0-80,0-119.9 c0-3.2-0.3-5.3-3.8-6.9C6,64.9,2,55.8,4,46.9c2.1-9.4,9.4-15.6,19.3-15.8C32,30.8,40.8,31,50.4,31z M28.6,71.3 c0,43-0.2,85.5,0.1,127.9c0.1,12.2,6.9,18.1,19.1,18.1c26.3,0,52.6,0,78.9,0c5.7,0,11.3,0.1,17-0.1c8.8-0.3,14.9-6.1,15.9-14.9 c0.2-2,0.3-4,0.3-6c0-39.8,0-79.6,0-119.4c0-1.8,0-3.6,0-5.6C115.9,71.3,72.5,71.3,28.6,71.3z M94.4,41.7c-20.8,0-41.7,0-62.5,0 c-3.3,0-6.7-0.1-10,0.3c-4.8,0.6-7.7,4.1-7.8,8.9C14,55.3,16.6,58.9,21,60c1.4,0.4,2.9,0.6,4.4,0.6c46,0,92,0,138,0 c1.5,0,3-0.3,4.4-0.7c3.9-0.9,5.9-3.6,6.5-7.4c0.6-3.9-0.5-7.5-4.3-9.3c-2.5-1.1-5.4-1.6-8.1-1.6C139.4,41.6,116.9,41.7,94.4,41.7z  M60.8,30.5c22.5,0,44.6,0,66.7,0c1.2-12.5-2.1-16.2-14.3-16.2c-12.6,0-25.3,0-37.9,0C63.3,14.4,60,18,60.8,30.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E7E7E",
  stroke: "#7E7E7E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  d: "M120.1,139.3c0-15.1,0-30.3,0-45.4 c0-1.7-0.4-3.7,0.4-4.9c1-1.6,3-3.6,4.6-3.7c1.6-0.1,3.7,1.7,4.9,3.3c0.8,1.1,0.5,3.2,0.5,4.8c0,30.9,0,61.9,0,92.8 c0,1.2,0.4,2.7-0.2,3.4c-1.5,1.8-3.4,4.3-5.4,4.6c-1.4,0.2-3.8-2.7-4.6-4.6c-0.8-2-0.3-4.6-0.3-6.9 C120.1,168.2,120.1,153.7,120.1,139.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E7E7E",
  stroke: "#7E7E7E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  d: "M58.2,139.3c0-15.3,0-30.6,0-45.9 c0-1.7-0.3-3.7,0.5-4.9c1.1-1.5,3.2-3.2,4.9-3.3c1.5-0.1,3.4,1.8,4.4,3.3c0.8,1.2,0.5,3.2,0.5,4.9c0,30.9,0,61.9,0,92.8 c0,1.3,0.4,3.1-0.3,3.9c-1.4,1.7-3.3,4-5.2,4.2c-1.5,0.1-3.5-2.4-4.6-4.1c-0.7-1.1-0.3-2.9-0.3-4.4 C58.2,170.2,58.2,154.8,58.2,139.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E7E7E",
  stroke: "#7E7E7E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  d: "M99.5,140.1c0,15.3,0,30.6,0,45.9 c0,1.7,0.3,3.7-0.5,4.9c-1.1,1.6-3.1,3.5-4.7,3.4c-1.6,0-3.6-1.9-4.7-3.5c-0.8-1.2-0.4-3.2-0.4-4.9c0-30.8,0-61.6,0-92.3 c0-1.5-0.4-3.4,0.3-4.4c1.2-1.7,3.1-3.7,4.9-3.9c1.5-0.1,3.6,1.9,4.7,3.5c0.8,1.2,0.4,3.2,0.4,4.9 C99.5,109.1,99.5,124.6,99.5,140.1z"
}));

var SvgIconDelete = function SvgIconDelete(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "189px",
    height: "231px",
    viewBox: "0 0 189 231",
    enableBackground: "new 0 0 189 231",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-delete.731b8a42.svg";
export { ForwardRef as ReactComponent };